import { z } from 'zod'

export const emailSchema = z.email({ message: 'E-mail inválido' })
